import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import type { MotionScope, Quality } from './contracts';

gsap.registerPlugin(ScrollTrigger);
export { gsap, ScrollTrigger };

export function createMotionScope(host: HTMLElement): MotionScope {
  return {
    reduced: matchMedia('(prefers-reduced-motion: reduce)').matches,
    context: gsap.context(() => {}, host),
    dispose() { this.context.revert(); },
  };
}

/** One clock shared by GSAP, ScrollTrigger and Lenis. Native scrolling remains usable. */
export function createScroll(quality: Quality): () => void {
  if (quality === 'lightweight' || matchMedia('(prefers-reduced-motion: reduce)').matches) return () => {};
  const lenis = new Lenis({ autoRaf: false, duration: 1.1 });
  const tick = (seconds: number) => lenis.raf(seconds * 1000);
  const sync = () => ScrollTrigger.update();
  lenis.on('scroll', sync);
  gsap.ticker.add(tick);
  return () => { gsap.ticker.remove(tick); lenis.off('scroll', sync); lenis.destroy(); };
}
